import { useQuery } from "@tanstack/react-query";

import { PRACTICE_MANAGEMENT_ENDPOINTS, getPracticeManagementPigletParameters } from "services";

import { PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_PIGLET_PARAMETERS } from "consts";

export const usePracticeManagementPigletParameters = (country: PracticeManagement.CountryCode = "global") =>
  useQuery({
    queryKey: [PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_PIGLET_PARAMETERS, country],
    // Country-only resource: one row, and no domain-specific key, so the endpoint path stands in as the editing key
    queryFn: async () => {
      const parameters = await getPracticeManagementPigletParameters(country);
      return {
        ...parameters,
        editingKey: PRACTICE_MANAGEMENT_ENDPOINTS.PIGLET_PARAMETERS,
      };
    },
    staleTime: 1000 * 60 * 60, // 1h
    gcTime: 1000 * 60 * 24, // 24h
  });
